export default __webpack_public_path__ + "static/media/SM.1c9a6677.svg";